import { render, staticRenderFns } from "./detalles.vue?vue&type=template&id=bbf2fc3a&"
import script from "./detalles.vue?vue&type=script&lang=js&"
export * from "./detalles.vue?vue&type=script&lang=js&"
import style0 from "./detalles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\laragon\\www\\elipse-citas\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbf2fc3a')) {
      api.createRecord('bbf2fc3a', component.options)
    } else {
      api.reload('bbf2fc3a', component.options)
    }
    module.hot.accept("./detalles.vue?vue&type=template&id=bbf2fc3a&", function () {
      api.rerender('bbf2fc3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/reportes/Erroresintegraciones/detalles.vue"
export default component.exports